<template>
    <p><button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button></p>
</template>

<script setup lang="ts">
// Hides OneTrust modal overlay
function hideOTModalOverlay() {
    const elementToHide = document.querySelector('#onetrust-consent-sdk .onetrust-pc-dark-filter');
    if (elementToHide) {
        // add delay for smoother animation
        setTimeout(() => {
            // @ts-expect-error - elementToHide is not in type
            elementToHide.style.display = 'none';
        }, 500);
    }
}

// HIDE OneTrust modal overlay, which sometimes stay after click on close button
function otModalClickHandler(event: MouseEvent) {
    // check if click was on OneTrust modal close btn
    // @ts-expect-error - event.target is not in type
    if (event.target?.id === 'close-pc-btn-handler') {
        // Check if OneTrust banner is visible
        const banner = document.getElementById('onetrust-banner-sdk');
        const bannerStyle = banner ? getComputedStyle(banner) : null;
        if (bannerStyle?.display === 'none') {
            // Hide modal overlay
            hideOTModalOverlay();
        }
    }
}

// removes OneTrust modal overlay after Esc button was pressed
function otModalEscBtnHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Esc') {
        // Check for the Escape key

        const closeBtn = document.getElementById('close-pc-btn-handler');
        if (closeBtn) {
            // Check if the element is in the viewport
            const rect = closeBtn.getBoundingClientRect();
            const inViewport =
                rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
                rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
                rect.bottom > 0 &&
                rect.right > 0;

            if (inViewport) {
                // Hide modal overlay
                hideOTModalOverlay();
            }
        }
    }
}

onMounted(() => {
    // add event Listener on document, because we can't be sure that onetrust modals were already loaded onMounted
    document.addEventListener('click', otModalClickHandler);
    document.addEventListener('keydown', otModalEscBtnHandler);
});
onUnmounted(() => {
    document.removeEventListener('click', otModalClickHandler);
    document.removeEventListener('keydown', otModalEscBtnHandler);
});
</script>

<style scoped lang="postcss"></style>
